<template>

	<JsonViewer
		:value="value"
		class="ao-p3-regular"
	/>

</template>

<script>
import JsonViewer from 'vue-json-viewer'

export default {

	name: 'AoJsonViewer',

	components: {
		JsonViewer,
	},

	props: {

		value: [String, Number, Object, Array],

	},

	emits: {},

	data: () => ({

		//data

	}),

	computed: {},

	created() {},

	methods: {},

}
</script>

<style lang="scss">
.jv-container {

	.jv-code {
		padding: 0.25rem;
	}

}
</style>
